import { useTicketList } from "@jugl-web/domain-resources/tickets/hooks/useTicketList";
import { TicketSortDirection } from "@jugl-web/rest-api/tickets/models/common-types/TicketSortDirection";
import { createContext } from "react";

export interface TicketsViewContextValue {
  ticketListQuery: ReturnType<typeof useTicketList>;
  searchQuery: string;
  sort: TicketSortDirection;
  setSearchQuery: (query: string) => void;
  setSort: (sort: TicketSortDirection) => void;
}

export const TicketsViewContext = createContext<TicketsViewContextValue | null>(
  null
);
